import React from 'react';
import { School, BookOpen } from 'lucide-react';

const Antecedentes = ({ formData, handleInputChange }) => {
    const inputClasses = `w-full p-1.5 rounded-lg border border-gray-300 bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`;

    return (
        <div className="bg-white rounded-lg p-4 max-w-4xl mx-auto">
            <h3 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2 flex items-center">
                <School className="mr-2 text-blue-500 w-4 h-4" />
                Antecedentes Escolares
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="institucion_anterior" className="block text-xs font-medium text-gray-700 mb-1">
                        Institución anterior
                    </label>
                    <input
                        type="text"
                        id="institucion_anterior"
                        name="institucion_anterior"
                        value={formData.institucion_anterior || ''}
                        onChange={handleInputChange}
                        className={inputClasses}
                        placeholder="Ingrese la institución anterior"
                    />
                </div>

                <div>
                    <label htmlFor="expectativas_institucion" className="block text-xs font-medium text-gray-700 mb-1">
                        <div className="flex items-center">
                            <BookOpen className="mr-1 w-3 h-3" />
                            Expectativas de la Institución
                        </div>
                    </label>
                    <textarea
                        id="expectativas_institucion"
                        name="expectativas_institucion"
                        value={formData.expectativas_institucion || ''}
                        onChange={handleInputChange}
                        rows="3"
                        className={inputClasses}
                        placeholder="Describa sus expectativas"
                    />
                </div>
            </div>
        </div>
    );
};

export default Antecedentes;
